import * as actions from './actions'
import mutations from './mutations'

const state = () => ({
  grupoUsuario: null,
  grupoUsuarioSalvo: null,
  grupoUsuarioInativo: null,
  grupoUsuarioAtributo: null,
  menuTreeTablesNodes: [
    {
      key: '789',
      data: {
        descricao: 'Autoatendimento'
      },
      children: [
        {
          key: '789-0',
          data: {
            descricao: 'Relatórios'
          },
          children: [
            {
              key: '789-6',
              data: {
                descricao: 'Agendados'
              }
            },
            {
              key: '789-1',
              data: {
                descricao: 'Funcionário'
              }
            },
            {
              key: '789-2',
              data: {
                descricao: 'Jornada de Trabalho'
              }
            },
            {
              key: '789-3',
              data: {
                descricao: 'Histórico de equipagem dos trens'
              }
            },
            {
              key: '789-4',
              data: {
                descricao: 'Atividades Excedentes'
              }
            },
            {
              key: '789-5',
              data: {
                descricao: ' Divergência Ponto-OS'
              }
            },
            {
              key: '789-7',
              data: {
                descricao: 'Críticas de Intrajornada'
              }
            },
            {
              key: '789-8',
              data: {
                descricao: 'Atividades'
              },            
              children: [
                {
                  key: '789-8-1',
                  data: {
                    descricao: 'Exibir ativas'
                  }
                },
                {
                  key: '789-8-2',
                  data: {
                    descricao: 'Exibir desconsideradas'
                  }
                }                
              ]
            },
            {
              key: '789-9',
              data: {
                descricao: 'Adicionais'
              }
            },
            {
              key: '789-10',
              data: {
                descricao: 'Divergências'
              }
            },
            {
              key: '789-11',
              data: {
                descricao: 'Críticas de atividade'
              }
            },
            {
              key: '789-12',
              data: {
                descricao: 'Log de Eventos'
              }
            },
            {
              key: '789-13',
              data: {
                descricao: 'Horas Diurnas x Noturnas'
              }
            },
            {
              key: '789-14',
              data: {
                descricao: 'Cerca Eletrônica'
              }
            }
          ]
        }
      ]
    },
    {
      key: '1',
      data: {
        descricao: 'Mobile'
      },
      children: [
        {
          key: '1-0',
          data: {
            descricao: 'Registro de Ponto'
          }
        },
        {
          key: '1-1',
          data: {
            descricao: 'Ajustes e Consultas de Frequência'
          },
          children: [
            {
              key: '1-2',
              data: {
                descricao: 'Incluir registro de ponto'
              }
            },
            {
              key: '1-3',
              data: {
                descricao: 'Alterar registro de ponto'
              }
            },
            {
              key: '1-4',
              data: {
                descricao: 'Desconsiderar registro de ponto'
              }
            },
            {
              key: '1-5',
              data: {
                descricao: 'Visualizar'
              }
            },
            {
              key: '1-6',
              data: {
                descricao: 'Justificativa'
              },
              children: [
                {
                  key: '1-6-1',
                  data: {
                    descricao: 'Incluir'
                  }
                },
                {
                  key: '1-6-2',
                  data: {
                    descricao: 'Alterar'
                  }
                },
                {
                  key: '1-6-3',
                  data: {
                    descricao: 'Excluir'
                  }
                }
              ]
            }
          ]
        },
        {
          key: '1-7',
          data: {
            descricao: 'Aprovações'
          },
          children: [
            {
              key: '1-8',
              data: {
                descricao: 'Aprovar e reprovar solicitações'
              }
            },
            {
              key: '1-9',
              data: {
                descricao: 'Cancelar a própia solicitação'
              }
            },
            {
              key: '1-10',
              data: {
                descricao: 'Visualizar '
              }
            }
          ]
        },
        {
          key: '1-11',
          data: {
            descricao: 'Indisponibilidade'
          },
          children: [
            {
              key: '1-12',
              data: {
                descricao: 'Incluir'
              }
            },
            {
              key: '1-13',
              data: {
                descricao: 'Alterar'
              }
            },
            {
              key: '1-14',
              data: {
                descricao: 'Cancelar'
              }
            },
            {
              key: '1-15',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '1-16',
          data: {
            descricao: 'Ordem de serviço'
          }
        },
        {
          key: '1-17',
          data: {
            descricao: 'Biometria facial'
          },
          children: [
            {
              key: '1-18',
              data: {
                descricao: 'Inativar biometria facial'
              }
            }
          ]
        },
      ]
    },
    {
      key: '2',
      data: {
        descricao: 'Web'
      },
      children: [
        {
          key: '792',
          data: {
            descricao: 'Ajustes e Consultas de Frequência'
          },
          children: [
            {
              key: '792-1-0',
              data: {
                descricao: 'Incluir registro de ponto'
              }
            },
            {
              key: '792-1-1',
              data: {
                descricao: 'Alterar registro de ponto'
              }
            },
            {
              key: '792-1-2',
              data: {
                descricao: 'Desconsiderar registro de ponto'
              }
            },
            {
              key: '792-3',
              data: {
                descricao: 'Visualizar'
              }
            },
            {
              key: '792-4',
              data: {
                descricao: 'Justificativa'
              },
              children: [
                {
                  key: '792-4-1-0',
                  data: {
                    descricao: 'Incluir'
                  }
                },
                {
                  key: '792-4-1-1',
                  data: {
                    descricao: 'Alterar'
                  }
                },
                {
                  key: '792-4-1-2',
                  data: {
                    descricao: 'Excluir'
                  }
                }
              ]
            }
          ]
        },
        {
          key: '800',
          data: {
            descricao: 'Aprovações'
          },
          children: [
            {
              key: '800-1-1',
              data: {
                descricao: 'Aprovar e reprovar solicitações'
              }
            },
            {
              key: '800-1-2',
              data: {
                descricao: 'Cancelar a própia solicitação'
              }
            },
            {
              key: '800-1-3',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '791',
          data: {
            descricao: 'Histórico de delegação'
          }
        },
        {
          key: '793',
          data: {
            descricao: 'Justificativa de Ocorrência'
          }
        },
        {
          key: '794',
          data: {
            descricao: 'Cadastro de Atividades'
          }
        },
        {
          key: '790',
          data: {
            descricao: 'Autorizações'
          },
          children: [
            {
              key: '790-1',
              data: {
                descricao: 'Grupo Usuário'
              },
              children: [
                {
                  key: '790-1-0',
                  data: {
                    descricao: 'Incluir'
                  }
                },
                {
                  key: '790-1-1',
                  data: {
                    descricao: 'Alterar'
                  }
                },
                {
                  key: '790-1-2',
                  data: {
                    descricao: 'Excluir'
                  }
                },
                {
                  key: '790-1-3',
                  data: {
                    descricao: 'Visualizar'
                  }
                }
              ]
            }
          ]
        },
        {
          key: '796',
          data: {
            descricao: 'Configurações Gerais'
          }
        },
        {
          key: '795',
          data: {
            descricao: 'Perfil Frequência'
          }
        },
        {
          key: '797',
          data: {
            descricao: 'Período de Apuração'
          }
        },
        {
          key: '798',
          data: {
            descricao: 'Bloqueio de Subperíodo'
          },
          children: [
            {
              key: '798-1-1',
              data: {
                descricao: 'Alterar'
              }
            },
            {
              key: '798',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '799',
          data: {
            descricao: 'Desbloqueio de Subperiodo'
          },
          children: [
            {
              key: '799-1',
              data: {
                descricao: 'Incluir'
              }
            },
            {
              key: '799-3',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '801',
          data: {
            descricao: 'Cadastro de Motivos'
          },
          children: [
            {
              key: '801-1-1',
              data: {
                descricao: 'Incluir'
              }
            },
            {
              key: '801-1-2',
              data: {
                descricao: 'Alterar'
              }
            },
            {
              key: '801-1-3',
              data: {
                descricao: 'Excluir'
              }
            },
            {
              key: '801-1-4',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '802',
          data: {
            descricao: 'Indisponibilidade'
          },
          children: [
            {
              key: '802-1-1',
              data: {
                descricao: 'Incluir'
              }
            },
            {
              key: '802-1-2',
              data: {
                descricao: 'Alterar'
              }
            },
            {
              key: '802-1-3',
              data: {
                descricao: 'Cancelar'
              }
            },
            {
              key: '802-1-4',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },

        {
          key: '803',
          data: {
            descricao: 'Ordem de serviço'
          },
          children: [
            {
              key: '803-1-2',
              data: {
                descricao: 'Aceitar'
              }
            },
            {
              key: '803-1-3',
              data: {
                descricao: 'Recusar'
              }
            },
            {
              key: '803-1-4',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '804',
          data: {
            descricao: 'Consolidação Folha'
          }
        },

        {
          key: '806',
          data: {
            descricao: 'Biometria facial'
          },
          children: [
            {
              key: '806-1-1',
              data: {
                descricao: 'Inativar biometria facial'
              }
            }
          ]
        },

        {
          key: '805',
          data: {
            descricao: 'Cerca eletrônica'
          },
          children: [
            {
              key: '805-1-1',
              data: {
                descricao: 'Incluir'
              }
            },
            {
              key: '805-1-2',
              data: {
                descricao: 'Alterar'
              }
            },
            {
              key: '805-1-3',
              data: {
                descricao: 'Excluir'
              }
            },
            {
              key: '805-1-4',
              data: {
                descricao: 'Visualizar'
              }
            }
          ]
        },
        {
          key: '807',
          data: {
            descricao: 'Reconversão Manual'
          }
        },
        {
          key: '808',
          data: {
            descricao: 'Alerta Registro Ponto'
          }
        }
      ]
    }
  ]
})

const grupoUsuario = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default {
  grupoUsuario
}
